import { Lot } from '../types/lot';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/lot/list';

export namespace LotRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<Lot>> => {
    return (await http.post(LIST, payload)).data;
  };
}
